export const AWS_IOT_BASE_URL = process.env.REACT_APP_AWS_IOT_BASE_URL || 'https://ppddxpqkmj.execute-api.ap-south-1.amazonaws.com';
export const CLIENT_API_BASE_URL = process.env.REACT_APP_CLIENT_API_BASE_URL || '';

const ROUTES = {
    /* AWS IOT Policy*/
    ATTACH_POLICY : `${AWS_IOT_BASE_URL}/attachPolicy`,

    /* Housie Game */
    TAMBOLA : `${CLIENT_API_BASE_URL}/tambola`,

    /* RapFire */
    RAPFIRE : `${CLIENT_API_BASE_URL}/rapFire`,
    RAPFIRE_PRIVATE : `${CLIENT_API_BASE_URL}/rf/private`,
    RAPFIRE_TOURNAMENT : `${CLIENT_API_BASE_URL || 'https://api.rapchiklife.com/api/client/v1'}/rf/tournament`,

    /** User Profile */
    USER : `${CLIENT_API_BASE_URL}/user`,
}

const ENDPOINTS = {
    /** MQTT */
    ATTACH_POLICY_ENDPOINT : (identityId) => `${ROUTES.ATTACH_POLICY}/${identityId}`,

    /** Authentication & User Profile */
    GET_PROFILE : `${ROUTES.USER}/get-profile`,
    CREATE_PROFILE : `${ROUTES.USER}/create-profile`,
    GET_USER_NOTIFICATIONS : `${ROUTES.USER}/notifications`,
    MARK_ALL_NOTIFICATIONS_READ : `${CLIENT_API_BASE_URL}/notifications/read-all`,

    /** Housie Game */
    //TAMBOLA_GAME_LIST : `${ROUTES.TAMBOLA}/list/?user=guest`,
    TAMBOLA_GAME_LIST : `${ROUTES.TAMBOLA}/list`,
    TAMBOLA_BUY_TICKET : (gameId) => `${ROUTES.TAMBOLA}/game/${gameId}/buyTicket`,
    TAMBOLA_JOIN_GAME : (gameId) => `${ROUTES.TAMBOLA}/game/${gameId}/join/?user=guest`,
    TAMBOLA_ENTITY_TRIVIA_CARD : (entityId) => `${ROUTES.TAMBOLA}/trivia-cardV2/${entityId}`,
    TAMBOLA_LEADERBOARD : (gameId) => `${ROUTES.TAMBOLA}/game/${gameId}/leaderboard/?user=guest`,
    
    /** Rap Housie Room */
    TAMBOLA_USER_ROOM : `${ROUTES.TAMBOLA}/user-room`,
    TAMBOLA_SELECT_ROOM : `${ROUTES.TAMBOLA}/select-room`,
    TAMBOLA_CREATE_ROOM : `${ROUTES.TAMBOLA}/create-room/V2`,
    TAMBOLA_JOIN_ROOM : `${ROUTES.TAMBOLA}/join-room`,
    TAMBOLA_GAME_ROOM : (roomId) => `${ROUTES.TAMBOLA}/game-room/${roomId}`,

    /** RapFire Game */
    RAPFIRE_GAME_LIST : `${ROUTES.RAPFIRE}/webConsole/contest`,
    RAPFIRE_GAME_PARTICIPANTS_LIST : (contestId) => `${ROUTES.RAPFIRE}/contest/participants?contestId=${contestId}`,
    RAPFIRE_GAME_DETAIL : (gameId) => `${ROUTES.RAPFIRE}/game-detail/${gameId}`,
    RAPFIRE_LEADERBOARD : (gameId) => `${ROUTES.RAPFIRE}/leaderboard/${gameId}`,
    TOURNAMENT_LEADERBOARD : (tournamentId) =>
        `${ROUTES.RAPFIRE_TOURNAMENT}/${tournamentId}/leaderboard`,

    /** Rap Fire Room */
    RAPFIRE_USER_ROOM : `${ROUTES.RAPFIRE_PRIVATE}/host-rooms`,
    RAPFIRE_SELECT_ROOM : `${ROUTES.RAPFIRE}/select-room`,
    RAPFIRE_CREATE_ROOM : `${ROUTES.RAPFIRE_PRIVATE}/create-room/V2`,
    RAPFIRE_JOIN_ROOM : `${ROUTES.RAPFIRE_PRIVATE}/join-room`,
    RAPFIRE_GAME_ROOM : (contestId) => `${ROUTES.RAPFIRE_PRIVATE}/game-room/${contestId}`,
    RAPFIRE_START_GAME : (contestId) => `${ROUTES.RAPFIRE_PRIVATE}/start-game/${contestId}`,
};

export default {ENDPOINTS,ROUTES,AWS_IOT_BASE_URL,CLIENT_API_BASE_URL};